import { PUBLIC_SUPABASE_ANON_KEY, PUBLIC_SUPABASE_URL } from '$env/static/public'
import type { LayoutLoad } from './$types'
import { createBrowserClient, createServerClient, isBrowser, parse } from '@supabase/ssr'
import type { Database } from '../../database.types'

export const load: LayoutLoad = async ({ fetch, data, depends }) => {
	depends('supabase:auth')

	const supabase = isBrowser()
		? createBrowserClient(PUBLIC_SUPABASE_URL, PUBLIC_SUPABASE_ANON_KEY, {
				global: {
					fetch
				}
			})
		: createServerClient(PUBLIC_SUPABASE_URL, PUBLIC_SUPABASE_ANON_KEY, {
				global: {
					fetch
				},
				cookies: {
					getAll() {
						return data.cookies
					}
				}
			})

	const {
		data: { session }
	} = await supabase.auth.getSession()

	const user = await supabase.from('profiles').select()

	if ((user.error || user.data.length === 0) && session) {
		await supabase.auth.signOut()

		return { supabase, session: null }
	}

	console.log('User: Logging user right now', user)

	return {
		supabase,
		session,
		user: user?.data?.[0] as Database['public']['Tables']['profiles']['Row'] | undefined
	}
}
